module.exports = __webpack_public_path__ + "img/white-unchecked-tick.ca96dc9a.svg";